import { ref } from 'vue';

const searchQuery = ref('');

const reset = () => {
  searchQuery.value = '';
};

export function useSearch() {
  return {
    searchQuery,
    reset,
  };
}
